import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const iconHeight = 20;

const useStyles = createUseStyles(
  ({ colors, breakpoints }: ITheme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    search: {
      display: 'block',
      position: 'relative',
      width: '100%',
    },
    icon: {
      height: iconHeight,
      left: 12,
      position: 'absolute',
      top: `calc(50% - ${iconHeight / 2}px)`,
      width: 20,
      cursor: 'pointer',

      '& path': {
        fill: '#999',
      },
    },

    collapsedIcon: {
      cursor: 'pointer',
      width: 24,
      height: 24,

      '& path': {
        fill: '#999',
      },
    },

    collasableInputIcon: {
      [mediaQuery(breakpoints.laptop)]: {
        width: 24,
        height: 24,
        top: `calc(50% - 12px)`,
        left: 16,

        '&:hover': {
          '& path': {
            fill: '#787878',
          },
        },

        '& path': {
          fill: colors.black,
        },
      },
    },
    input: {
      border: '2px solid var(--x-bg-7)',
      borderRadius: 12,
      color: 'var(--x-black-1)',
      fontSize: 14,
      fontWeight: 500,
      height: 40,
      paddingLeft: 42,
      paddingRight: 12,
      width: '100%',
      minWidth: 152,

      '&::placeholder': {
        color: 'var(--x-breadcrumb-last)',
      },

      '&:hover': {
        backgroundColor: 'var(--x-bg-5)',
      },
    },
    collapsableInput: {
      [mediaQuery(breakpoints.laptop)]: {
        width: 'calc(100vw - 320px)',
        transition: '.3s ease-in-out all',

        '&:not(:focus)': {
          width: 0,
          minWidth: 0,
          paddingRight: 0,
          borderColor: 'transparent',

          '&:hover': {
            backgroundColor: '#fff',
          },
        },
      },
    },
    resultsContainer: {
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 16,
      boxShadow: '0px 1px 4px var(--x-shadow-card)',
      maxHeight: 600,
      minWidth: 200,
      padding: 12,
      position: 'absolute',
      top: 'calc(100% + 12px)',
      textAlign: 'center',
      overflowY: 'auto',
      width: '100%',
      zIndex: 100,
    },
    results: {
      listStyleType: 'none',
    },
    resultsEntry: {
      alignItems: 'center',
      display: 'grid',
      gap: 8,
      gridTemplateColumns: '24px max-content',
      marginBlockEnd: 16,

      '& svg': {
        maxWidth: 16,
        maxHeight: 16,
      },
    },
    resultsEntryLink: {
      color: 'var(--x-text-color-1)',
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '16px',
      textDecoration: 'none',
    },
    resultsAllLink: {
      color: 'var(--x-text-color-4)',
      textAlign: 'left',
      width: '100%',

      '&:hover': {
        color: 'var(--x-text-color-4)',
      },
    },
    resultsAll: {
      fontSize: 10,
      fontWeight: 600,
      lineHeight: '24px',

      textDecoration: 'none',
    },
    resultsAllCategory: {},
    noResultsDescription: {
      fontSize: 10,
      fontWeight: 600,
      lineHeight: '14px',

      margin: '16px 12px 8px 12px',
    },
    noResultsList: {
      listStyleType: 'none',
      marginBottom: 4,
    },
    noResultsLink: {
      color: 'var(--x-accent-2-1)',
      fontSize: 10,
      fontWeight: 600,
      lineHeight: '24px',
    },
    defaultResultsList: {
      display: 'block',
      listStyleType: 'none',
    },
    defaultResultsLink: {
      alignItems: 'center',
      color: 'var(--x-text-color-1)',
      display: 'flex',
      fontSize: 12,
      gap: 8,
      marginBottom: 8,

      '&:last-child': {
        marginBottom: 'none',
      },
    },
  }),
  { name: 'SingleToolSearch' },
);

export default useStyles;
